import PropTypes from "prop-types";
import styles from "./styles";

export const ErrorMessage = ({ message, alt }) => {
  return (
    <span className={alt ? styles.errorMessageAlt : styles.errorMessage}>
      {message}
    </span>
  );
};

ErrorMessage.propTypes = {
  message: PropTypes.string,
  alt: PropTypes.bool,
};

ErrorMessage.defaultProps = {
  message: "",
};
